module.exports = __webpack_public_path__ + "img/pdf-file.48bee29c.svg";